
const COUPON_AUDIT_LIST = 'COUPON_AUDIT_LIST';
const COUPON_AUDIT_PAGE = 'COUPON_AUDIT_PAGE';
const COUPON_AUDIT_CONDITION = 'COUPON_AUDIT_CONDITION';
const COUPON_AUDIT_ADD_CONDITION = 'COUPON_AUDIT_ADD_CONDITION';

const CouponauditModel = function () {
  const name = 'Couponaudit';
  return {
    name,
    state: {
      list: [],
      condition: {
        title:'',
        couponType:'',
        useType:'',
        status:'',
      },
      addCondition:{
        title:'',
        details:'',
        startDt:'',
        endDt:'',
        ccount:'',
        minFee:'',
        totalFee:'',
        totalCount:'',
        couponType:'',
        coverFile:'',
        userType:'',
        userId:[],
        perLimit:'',
        priority:'',
        isShare:'',
        platform:'',
        productType:'',
        spuNo:'',
        exclusive:'',
        fixedTs:'',
        validCount:'',
        validUnit:'1',
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getAddCondition: () => currentState.addCondition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: COUPON_AUDIT_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: COUPON_AUDIT_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: COUPON_AUDIT_CONDITION,
          key,
          value
        });
      },
      changeAddCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: COUPON_AUDIT_ADD_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = CouponauditModel.state.list, action) => {
        if (action.type === COUPON_AUDIT_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = CouponauditModel.state.page, action) => {
        if (action.type === COUPON_AUDIT_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = CouponauditModel.state.condition, action) => {
        if (action.type === COUPON_AUDIT_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      addCondition: (state = CouponauditModel.state.addCondition, action) => {
        if (action.type === COUPON_AUDIT_ADD_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      }
    }
  };
}();

export default CouponauditModel;


// WEBPACK FOOTER //
// ./src/models/CouponauditModel.js